import { BaseResource } from './base';
import { RequestOptions, PaginatedResponseDto } from '../types';
import { GymCatalog, UpdateCatalogConfigDto, CatalogLead, LeadFiltersDto } from '../models/catalog';

/**
 * Admin Catalog Resource
 * Handles catalog administration operations (requires authentication and CATALOG permissions)
 */
export class AdminCatalogResource extends BaseResource {
  private basePath = 'admin/catalog';

  /**
   * Get catalog configuration for the current gym
   * Requires: CATALOG_READ permission
   */
  async getCatalogConfig(options?: RequestOptions): Promise<GymCatalog> {
    return this.client.get<GymCatalog>(this.basePath, undefined, options);
  }

  /**
   * Update catalog configuration
   * Requires: CATALOG_UPDATE permission
   */
  async updateCatalogConfig(
    data: UpdateCatalogConfigDto,
    options?: RequestOptions,
  ): Promise<GymCatalog> {
    return this.client.put<GymCatalog>(this.basePath, data, options);
  }

  /**
   * Get catalog leads with optional filtering
   * Requires: CATALOG_READ permission
   */
  async getLeads(
    filters?: LeadFiltersDto,
    options?: RequestOptions,
  ): Promise<PaginatedResponseDto<CatalogLead>> {
    return this.client.get<PaginatedResponseDto<CatalogLead>>(
      `${this.basePath}/leads`,
      filters,
      options,
    );
  }

  /**
   * Mark a lead as contacted
   * Requires: CATALOG_UPDATE permission
   */
  async markLeadAsContacted(
    leadId: string,
    options?: RequestOptions,
  ): Promise<{ id: string; isContacted: boolean; contactedAt: string }> {
    return this.client.patch<{ id: string; isContacted: boolean; contactedAt: string }>(
      `${this.basePath}/leads/${leadId}/mark-contacted`,
      undefined,
      options,
    );
  }
}
